// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3396":"c7f1271f","4292":"d71332ff","4755":"74613037","6674":"d265ffc6","8281":"c7f1271f"}[chunkId] + ".chunk.css";
};